var _defs, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialContributionOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    x1: 105.64,
    y1: 131.85,
    x2: 119.53,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 75.15,
    y1: 27.98,
    x2: 117.41,
    y2: 27.98,
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 76.15,
    y1: 40.98,
    x2: 118.41,
    y2: 40.98,
    gradientTransform: "translate(-1 -13)",
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 84.72,
    y1: 69.98,
    x2: 109.29,
    y2: 69.98,
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 88.08,
    y1: 103.82,
    x2: 148.16,
    y2: 103.82,
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 107.24,
    y1: 101.5,
    x2: 119.29,
    y2: 101.5,
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6",
    "data-name": "C_BG_shellbar",
    x1: 116.79,
    y1: 103.24,
    x2: 128.59,
    y2: 103.24,
    xlinkHref: "#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M89.03 132.85H61.71c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.12M115.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64v64.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M70.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 114.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67",
    stroke: "url(#SVGID_3_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M118.28 112.79v30.58c0 4.08-2.39 7.53-5.59 7.53-1.6 0-3.05-.82-4.1-2.16-1.05-1.34-1.7-3.19-1.7-5.23",
    stroke: "url(#SVGID_0_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M98.99 112.42c-3.69 0-7.07 1.58-9.66 4.19 3.1-15.12 14.78-26.35 28.71-26.35s26 11.62 28.87 27.11c-2.67-3.06-6.33-4.95-10.38-4.95-3.5 0-6.72 1.42-9.25 3.79-2.53-2.36-5.75-3.79-9.25-3.79s-6.96 1.53-9.53 4.06c-2.57-2.53-5.9-4.06-9.52-4.06z",
    stroke: "url(#SVGID_4_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M108.51 116.48s-1-16.92 9.53-26.22v-3.74",
    stroke: "url(#SVGID_5_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M127.29 116.21s1.28-16.64-9.25-25.94",
    stroke: "url(#SVGID_6_f04a142d2c708e1b8de155b4af743d7dc1ad6c045f37de2f2c75dfc0ba7523b6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialContributionOverview);
export default __webpack_public_path__ + "static/media/socialContributionOverview.324bb10aa6970f4ffed1aa5810c44f82.svg";
export { ForwardRef as ReactComponent };